import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

import builderSvg from '../../src/images/builder.svg'; // adjust path if needed
import LocalServiceBusinessPost from './Webapps2Folder/LocalServiceInsights';

// ─── All colors in ONE place ────────────────────────────────────────
const theme = {
//   backgroundLight: 'transparent',
//   backgroundLight: '#45FE47',
//   backgroundDark:  '#010606',
//   text:           '#fff',
//   text:           '#010606',
  textInverse:    '#f7f8fa',
  border:         '#010606',
  borderHover:    '#000000',
  buttonBg:       '#45FE47',
  buttonText:     '#010606',
  buttonHoverBg:  '#010606',
  buttonHoverText:'#f7f8fa',
};

// You only change the line below to switch "mode"
const isLight = true;   // ← change to false to switch to dark mode

// const sectionConfig = {
//   id: 'react',
//   isLight,               // ← controls background + text contrast
//   topLine: 'Creation Lab',
//   headline: 'Human-Centered Intelligence, Built for Real Use',
//   description:
//     'From neurodivergent-friendly learning tools to psychological frameworks, archetype systems, narrative AI demos, and business automations — these experiments turn complex cognitive ideas into simple, intuitive, human-centered experiences.',
//   buttonLabel: 'Explore Now',
//   buttonTo: 'templates',
// };

const sectionConfig = {
  id: 'react',
  isLight: false,               // ← dark/matrix-green theme fits your site; set true if you switch to light mode
  topLine: 'Creation Lab',
  headline: 'Practical AI, Built Human-First',
  // description:
  //   'Custom tools and systems that solve everyday problems — from neurodivergent learning aids and archetype-powered insights to mobile PWAs, automation agents, smart forms, and workflows for local trades, small businesses, and creators. Turn real needs into working solutions.',
  // description: `Custom tools solving real problems — from neurodivergent learning aids and archetype insights to mobile PWAs, automation agents, smart workflows, and practical preparedness systems for water, food, shelter, energy, security, and resilient off-grid living.`,
  description:
    'A living portfolio of tools and experiments — learning aids, archetype systems, PWAs, agents, and small-business workflows you can try or ship.',
  buttonLabel: 'Browse portfolio',
  buttonTo: '/templates',
};

const CreationLabSection = () => {
  const { id, isLight, topLine, headline, description, buttonLabel, buttonTo } = sectionConfig;

  return (
    <Section $isLight={isLight} id={id}>
      <Container>
        <Content>
          <Fade bottom cascade damping={0.2}>
            <TopLine $isLight={isLight}>{topLine}</TopLine>
            <Heading $isLight={isLight}>{headline}</Heading>
            <Subtitle $isLight={isLight}>{description}</Subtitle>

            <ButtonWrap>
              <Button to={buttonTo}>
                {buttonLabel}
              </Button>
            </ButtonWrap>
          </Fade>
        </Content>
      </Container>
    </Section>
  );
};

// ─── Styles ──────────────────────────────────────────────

const Section = styled.section`
  background: ${({ $isLight }) => $isLight ? theme.backgroundLight : theme.backgroundDark};
  border-top:    0.8px solid ${theme.border};
  border-bottom: 0.8px solid ${theme.border};
  border-top: 1px solid #45FE47;
`;

const Container = styled.div`
  padding: 80px 24px 0;
  margin: 0 auto;
  max-width: 1200px;
  display: grid;
  justify-content: center;
  /* background: linear-gradient(
    135deg,
    rgba(15, 25, 15, 0.92),
    rgba(20, 40, 20, 0.85)
    );
    backdrop-filter: blur(10px); */
  background: linear-gradient(135deg, rgba(15, 15, 15, 0.9), rgba(30, 30, 30, 0.8));
  backdrop-filter: blur(10px);
  /* background-color: #45FE47; */
  border-radius: 0 0 12px 12px;
  /* border: 1px solid #45FE47; */
  border-bottom: 1px solid #45FE47;
  border-top:    none;
  border-left:   1px solid #45FE47;
  border-right:  1px solid #45FE47;
  color: #fff;
  /* margin: 0px 20px; */
  @media (max-width: 1200px) {
    margin: 0px 25px;
  }
  @media (max-width: 768px) {
    padding: 60px 20px 0;
    border-radius: 0 0 0 0;
    border-bottom: none;
    /* border-bottom: 1px solid #45FE47; */
    border-top:    none;
    border-left:   none;
    border-right:  none;
    background: #45FE47;
    color: #010606;
    backdrop-filter: none;
   margin: 0px 0px;
  }
`;

const Content = styled.div`
  max-width: 800px;
  padding-bottom: 60px;

  @media (max-width: 768px) {
    padding-bottom: 40px;
  }
`;

const TopLine = styled.p`
  font-family: 'VT323', monospace;
  color: ${({ $isLight }) => $isLight ? theme.text : theme.textInverse};
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
   @media (max-width: 768px) {
     /* color: #45FE47; */
     color: #000;
  }
`;

const Heading = styled.h1`
  font-family: 'VT323', monospace;
  color: ${({ $isLight }) => $isLight ? theme.text : theme.textInverse};
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    color: #000;
  }

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

const Subtitle = styled.p`
  font-family: 'VT323', monospace;
  color: ${({ $isLight }) => $isLight ? theme.text : theme.textInverse};
  font-size: 24px;
  /* line-height: 1.4; */
  margin-bottom: 35px;
  @media (max-width: 768px) {
    color: #000;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Button = styled(Link)`
  font-family: 'VT323', monospace;
  background: ${theme.buttonBg};
  color: ${theme.buttonText};
  border: 1px solid ${theme.border};
  padding: 12px 40px;
  font-size: 18px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.buttonHoverBg};
    color: ${theme.buttonHoverText};
    border-color: ${theme.borderHover};
  }
`;

export default CreationLabSection;